import select2 from 'select2'; // eslint-disable-line

const SELECTOR = 'select.csn-select2';

const DEFAULTS = {
  theme: 'bootstrap'
};

class Selects {
  constructor() {
    if ($(SELECTOR).size()) {
      this.initialize();
    }

    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      if ($addedTask.find(SELECTOR).size() > 0) {
        this.initialize();
      }
    });
  }

  initialize() {


    $(SELECTOR).each(function(index, item) {
      let options = Object.assign({}, DEFAULTS);
      if (item.hasAttribute('multiple')) {
        options.closeOnSelect = false;
      }
      $(item).select2(options);
    });
  }
}

export default Selects;



// WEBPACK FOOTER //
// ./src/javascripts/Selects.js